module.exports = __webpack_public_path__ + "media/Video 142.9fa28e53.mp4";